export class Relation {
    public id: string;
    public name: string;
}

export const relationOptions: Relation[] = [
    { id:'father', name:$localize`Padre` }, 
    { id:'mother', name:$localize`Madre` },
    { id:'tutor', name:$localize`Tutor` }
];